module.exports = __webpack_public_path__ + "media/images/features/draft/eyecatch-flow-02-c260e57794ef8c127cb5608bcf110e76.png";